<template>
    <div class="lstGroups">
        <div v-for="(item, i) in content" :key="i" class="lstGroups-group">
            <p class="h2"> {{ item.title }} </p>
            <div v-for="(details, j) in item.details" :key="j" class="lstGroups-item">
                <p> {{ details.name }} </p>
                <div>
                    <p v-for="(specs, k) in details.specs" :key="k"> {{ specs }} </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ConfigCardModalContent',
        props:{
            content: {type: Array, default: () => { return []; }},
        },
    }
</script>
<style lang="scss" scoped>
    .lstGroups{
        &-group{ margin-bottom: 2rem;
            & > .h2{
                margin: .75rem 0;
            }
        }

        &-item{
            display: flex;
            justify-content: space-between;
            margin-bottom: 1.5rem;

            & > *{ flex-basis: 47.5%; }
            & > p{ font-family: $medium;}

            @include respond-to(maxLarge){
                & > :first-child { flex-basis: 30%;}
                & > :last-child{ flex-basis: 65%;}
            }
        }
    }
</style>
